import { z } from 'zod/v4';

/**
 * Response body for `DELETE /integrations/amfori/credentials`.
 *
 * The backend handler may alternatively reply with `204 No Content` (no
 * body). This schema describes the JSON envelope used when a 200 response
 * is returned.
 */
export const AmforiDeleteCredentialsResponseSchema = z
  .object({
    deleted: z.literal(true),
  })
  .strict();

export type AmforiDeleteCredentialsResponse = z.infer<
  typeof AmforiDeleteCredentialsResponseSchema
>;
